import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';

import { SnCamera, SnCameraManagementType, SnLiveVideoUrls } from '@lib/api/entities';
import { ISnPlayer } from '@lib/player/common';

@Component({
  selector: 'sn-cam-playback-card',
  templateUrl: './cam-playback-card.component.html',
  styleUrls: ['./cam-playback-card.component.scss'],
})
export class CamPlaybackCardComponent implements OnInit, OnDestroy {
  @Input() public camera: SnCamera;
  @Input() public src: any;
  @Output() public readonly remove = new EventEmitter<SnCamera>();

  private _startDate;
  private _endDate;
  private readonly _destroy$ = new Subject<void>();

  constructor() {}

  public ngOnInit(): void {
    this._startDate = new Date(Date.now() - 600 * 1000);
    this._endDate = new Date(Date.now());

    this.src =
      this.camera.isManaged && !this.isExternal && !this.camera.isFususCamera
        ? new SnLiveVideoUrls({
            main: this.camera.playbackUrls.main.toStreamSourceListFmp4(
              null,
              this._startDate,
              this._endDate,
            ),
          })
        : new SnLiveVideoUrls({
            main: this.camera.playbackUrls.main.toStreamSourceList(
              null,
              this._startDate,
              this._endDate,
            ),
          });
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public onPlayerInit(player: ISnPlayer): void {
    player.connected$.pipe(takeUntil(this._destroy$)).subscribe();
  }

  get isExternal(): boolean {
    if (this.camera) {
      return this.camera?.managementType === SnCameraManagementType.External;
    }
  }
}
